var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.57 21.31L23.83 22.57L22.57 23.83L21.31 22.57L22.57 21.31ZM22.57 8.16998L23.83 9.42998L17.26 16L21.76 20.5L20.5 21.76L16 17.26L9.43 23.83L8.17 22.57L14.74 16L8.17 9.42998L9.43 8.16998L16 14.74L22.57 8.16998Z",
    fill: "#00A200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 16C31.3 24.46 24.46 31.3 16 31.3C7.54 31.3 0.699997 24.46 0.699997 16C0.699997 7.54001 7.54 0.700012 16 0.700012C24.46 0.700012 31.3 7.54001 31.3 16ZM29.5 16C29.5 8.53001 23.47 2.50001 16 2.50001C8.53 2.50001 2.5 8.53001 2.5 16C2.5 23.47 8.53 29.5 16 29.5C23.47 29.5 29.5 23.47 29.5 16Z",
    fill: "#00A200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleClose);
export default __webpack_public_path__ + "static/media/circle-close.5845339058fab0150f19bf39745c1ea5.svg";
export { ForwardRef as ReactComponent };